const Translation = {
  access_point: "Access Point",
  accessPoints: "Access Points",
  vehicle_type: "Vehicle Type",
  vehicle_types: "Vehicle Types",
  booking_date: "Booking Date",
  booking_ref: "Booking Ref",
  error_something_went_wrong: "Something Went Wrong...",
  filters: "Filters",
  filter: "Filter",
  Status: "Status",
  statuses: "Statuses",
  Projects: "Projects",
  Organization: "Organization",
  organizations: "Organizations",
  Organizations: "Organizations",
  Tracking: "Tracking",
  vehicle_tracking: "Vehicle Tracking",
  vehicle_tracking_description:
    "Enable access to the vehicle tracking and mobile routing feature",
  reset_filter: "Reset Filter",
  apply_filter: "Apply Filters",
  users: "Users",
  total_user: "Total Users",
  total_Organization: "Total Organizations",
  active_users: "Active Users",
  clear_all: "Clear All",
  showing: "Showing",
  no_sdata_found: "No Data Found",
  entries_of: "entries of",
  entries: "entries",
  search_by_User_parameter_in_userlist:
    "Search by User Name, Organization Name, Email Address",
  search_by_project_name: "Search by Project Name",
  organization_Name: "Organization Name",
  organization_Admin: "Organization Admin",
  Country: "Country",
  associated_Projects: "Associated Projects",
  others: "others",
  search_by_organization_name: "Search by Organization Name",
  close: "Close",
  tap_to_edit: "Tap to edit profile picture",
  first_name_required: "First Name is required",
  last_name_required: "Last Name is required",
  email_name_required: "Email is required",
  phone_name_required: "Phone is required",
  email: "Email",
  phone: "Phone",
  save_details: "Save details",
  organization_role: "Organization Role",
  user_status: "User Status",
  global_user_status: "Global Admin Status",
  personal_details: "Personal Details",
  organization_created: "Successfully Created Organization",
  select_country: "Select Country",
  org_name_required: "Organization Name is required",
  address_required: "Address Name is required",
  city_required: "Town/City is required",
  saved_successfully: "Save Detail Successfully",
  organization_details: "Organization Details",
  address_line_1_required: "Address1 is Required",
  address_line_2_required: "Address2 is Required",
  zip_required: "ZIP is required",
  country_required: "Country is required",
  organization_logo: "Organization Logo",
  statement_info_text:
    "To include a link in the statement text use the following format {link text, https://link.com}.",
  question_required: "Question is required",
  create_project: "Create Project",
  user_data_saved_successfully: "Successfully updated user information ",
  section_visibility: "Section Visibility",
  project_setting: "Project Settings",
  project_settings_description:
    "Project settings is where ‘Pro’ features and integrations can be accessed and configured. Enabling this will make the Project Settings area visible and accessible to project admins.",
  integration: "Integrations ",
  integration_description:
    "Integrations is where 3rd party integrations can be enabled and configured. Enabling this will make the Integrations area visible and accessible to project admins. Integrations is contained within Project Settings, both must be active to access the Integrations area.",
  enable_pro_settings: "Enable Pro Settings",
  procore_daily_log: "Procore Daily Log",
  procore_daily_log_description:
    "Enable access to configure procore daily log. This feature relies on the procore integration. ",
  enable_integrations: "Enable Integrations",
  fors_validation: "FORS Validation",
  fors_validation_description: "Enable access to configure FORS validation.",
  procore: "Procore",
  procore_description: "Enable access to configure procore integration.",
  feature_updated: "Successfully Updated Feature",
  integrations_updated: "Successfully Updated Integrations",
  verification: "Verification",
  organization_state: "Organization State",
  select_org_state: "Please Select Organization State",
  verified_email_domain: "Verified Email Domains",
  email_domain_required: "Please Select Verified Email Domains",
  verified: "Verified",
  unverified: "UnVerified",
  scheduling: "Scheduling",
  field: "Field",
  edit: "Edit",
  duration: "Duration",
  core_fields: "Core Fields",
  active: "Active",
  summary: "Show in Summary",
  Active: "Active",
  Inactive: "Inactive",
  mandatory: "Mandatory",
  flexible_fields: "Flexible Fields",
  add_new_field: "Add new Field",
  core_field_saved_success_fully: "Save Successfully CoreField Detail",
  error_login_again: "Authentication Credentials not provided",
  fuel_type: "Fuel Type",
  included: "Included",
  cancel: "Cancel",
  save: "Save",
  change_associated_organization: "Change Associated Organization",
  confirm: "Confirm",
  new_organization: "New Organization",
  changed_organization: "Organization Changes SuccessFully",
  no_data_found: "No Data found",
  collapse: "Collapse",
  new_project: "New Project",
  field_removed: "Field Removed",
  this_field_is_active: "This Field is Active",
  this_field_is_mandatory: "This Field is Mandatory",
  core_field_saved: "Save Successfully CoreField Detail",
  search: "Search",
  from: "From",
  to: "To",
  today: "TODAY",
  yesterday: "YESTERDAY",
  start_date: "Start Date",
  end_date: "End Date",
  start_date_greater_than_end_date:
    "Start Date Should not be greater than End Date",
  back: "Back",
  account_created: "Account Created",
  last_login: "Last Login",
  link: "Link",
  status: "Status",
  First_Name: "First Name",
  Last_Name: "Last Name",
  Email_Address: "Email Address",
  Associated_Organization: "Associated Organization",
  Associated_Projects: "Associated Projects",
  account_manager: "Account Manager",
  organization: "Organization",
  apply_filters: "Apply Filters",
  next: "Next",
  previous: "Previous",
  no_activity_found: "No Activity Found",
  create_organization: "Add New Organization",
  forgot_password: "Forgot Password",
  welcometext_forgot:
    "Please enter your email and we will send you instructions to reset your password.",
  backtologin: "Back to login",
  submit: "Submit",
  error_email_required: "Email is required",
  error_valid_email: "Please enter valid email address",
  welcometext: "Welcome To Voyage Control",
  pls_login: "Please Log In",
  password: "Password",
  login: "Login",
  booking_type: "Booking Type",
  site_defaults: "Site Defaults",
  project: "Projects",
  total_project: "Total Projects",
  project_status: "Project Status",
  active_project: "Active Projects",
  site_settings: "Site Settings",
  automatic_approval: "Automatic Approval",
  Approved: "Approved",
  Blocked: "Blocked",
  Pending: "Pending",
  automatic_approval_description:
    "All Booking will automatically approved after they are made.",
  unauthorize_user: "Access Denied",
  edit_project_details: "Edit Project Detail",
  credential_not_provided: "Authentication Credentials Not Provided",
  region_not_available: "Current region not available",
  btn_back: "Back",
  date_created: "Date Created",
  local_site_time: "Local Time at Site",
  successfully_edit_contact: "Successfully Edit Contact",
  invalid_url: "Please enter valid URL",
  project_owner_email_address: "Project Owner Email Address",
  project_edited: "Project Details Edited SuccessFully",
  please_contact_selected_owner_to_accept_the_invitation:
    "Please Contact selected Owner To Accept the Invitation",
  please_select_owner: "Please select Owner",
  success_fully_added_contact: "Successfully Add Contact",
  image_uploaded: "Successfully uploaded Image",
  contact_deleted: "Successfully deleted Contact",
  project_organization: "Project Organization",
  select_site: "Select Site",
  any_integration_lost: "Any integration configurations with be lost",
  disable: "Disable",
  go: "GO",
  actions: "Actions",
  go_to_project: "Go to project",
  project_settings_updated: "Project Setting Updated",
  invalid_date: "Invalid Date",
  added_flexible_field_data: "Add Flexible Field Data",
  title_is_required: "Title is required",
  question_is_required: "Question is required",
  option_is_required: "Option is required",
  title: "Title*",
  question: "Question*",
  statement: "Statement*",
  field_type: "Field Type*",
  options: "Options",
  add: "Add",
  add_new_option: "Add New Option",
  edit_field: "Edit Field",
  add_field: "Add Field",
  free_text: "Free Text",
  confirm_text: "Are you sure you want to permanently delete this",
  can_not_undo: "You can’t undo this action",
  delete: "Delete",
  select_role: "Select Role",
  user_removed: "User is removed From Organization",
  organization_updated: "Organization Role updated",
  no_user: "No User found ",
  flex_fields_added: "Add Successfully Flexible Field",
  edit_flex_field: "Edit Flexible Field",
  add_flex_field: "Add New Flexible Field",
  org_name: "Organization Name",
  address_line_1: "Address Line 1",
  address_line_2: "Address Line 2",
  town_city: "Town/City",
  town_city_required: "Town/City is Required",
  zip_code: "Zipcode",
  zip_code_required: "Zipcode is Required",
  country: "Country",
  reset_password: "Reset Password",
  welcometext_reset: "The password shoud have atleast 6 characters",
  confirmpassword: "Confirm Password",
  forms: "Forms",
  save_to_preset_form: "Save to preset forms",
  delete_preset_form: "Delete Preset Form",
  edit_preset_form: "Edit Preset Form",
  section: "Section",
  create_new_form: "Create New Form",
  some_required_field_is_missing: "Missing some required fields",
  added_flexible_form: "Successfully added new flexible form",
  save_form: "Save Form",
  question_is_mandatory: "Question is mandatory",
  please_add_one_option: "Please add at least one option",
  please_add_value: "Please enter a value",
  please_fill_the_required_fields: "Please fill the all required fields",
  error_password_required: "Password is required",
  error_confirm_password_required: "Confirm Password is required",
  error_password_upper: "At least 1 uppercase character",
  error_password_lower: "At least 1 lowercase character",
  error_password_number: "At least 1 digit",
  error_password_special: "At least 1 special character",
  error_password_min: "Minimum 6 characters",
  error_password_max: "Maximum 16 characters",
  error_valid_password:
    "At least 1 uppercase character,At least 1 lowercase character, At least 1 digit, At least 1 special character,Minimum 6 characters and Maximum 16 characters.",
  error_password_not_match: "The passwords do not match",
  success_message: "Password Reset Successfully",
  error_language_required: "Language is required",
  error_dateformat_required: "Date Formate is required",
  error_timeformat_invalid: "Timeformat is required",
  error_startday_required: "StartDay is required",
  error_status_required: "Status is required",
  details_heading_text: "Project Details",
  project_name: "Project Name",
  project_lead: "Project Lead",
  project_owner: "Project Owner",
  project_org: "Project Organization",
  project_add: "Address",
  edit_project_detail: "Edit project details",
  heading_contact: "Contact Details",
  logo: "Logo",
  home_page_banner: "Home Banner",
  details_image_text: "Images & Home Screen",
  label_sitename: "Project Name",
  label_siteadd: "Project Address",
  label_siteOwner: "Project Owner",
  label_siteOrg: "Project Organization",
  label_accManager: "Account Manager",
  label_hubspot: "Hubspot Link",
  label_home_banner: "Home Banner",
  label_region: "Region",
  error_region_required: "Region is required",
  label_home_screen_message: "Home Screen Message",
  error_image_invalid: "Please upload valid image file",
  error_siteLogo_required: "Site Logo is required",
  error_homebanner_required: "Banner Image is required",
  error_sitename_required: "Project Name is required",
  error_siteadd_required: "Project Address is required",
  error_siteowner_required: "Project Owner is required",
  error_siteorg_required: "Project Organization is required",
  error_acc_manager_required: "Account Manager is required",
  error_hubspot_url: "Hubspot Url is required",
  error_homemessage_required: "Home Screen Message is required",
  contact_heading_text: "Contacts",
  add_contact: "Add New Contact",
  edit_contact: "Edit Contact",
  label_name: "Name",
  label_position: "Position",
  label_phone: "Phone Number (Optional)",
  btn_add: "Add",
  btn_remove: "Remove",
  btn_edit: "Edit",
  btn_save: "Save",
  error_name_required: "Name is required",
  error_position_required: "Position is required",
  error_valid_phonenumber: "Please enter valid Phone Number",
  error_required_phone: "Phone is required",
  drag_and_drop: "Drag and drop your files or",
  browse_file: "BROWSE FILES",
  image_uploading: "Uploading Image",
  select: "Select",
  address: "Address",
  hubspot: "HubSpot",
  "pre-live": "PRE-LIVE",
  paused: "PAUSED",
  finished: "Finished",
  invited: "Invited",
  Invited: "Invited",
  restricted: "Restricted",
  blocked: "Blocked",
  logout: "Logout",
  email_optional_label: "Email Address (Optional)",
  project_information: "Project Information",
  project_settings: "Project Settings",
  booking_fields: "Booking Fields",
  project_users: "Project Users",
  project_activity: "Project Activity",
  equipment_master_copy: "Copy From Master",
  emission_tracking: "Emission Tracking",
  equipment_emissions: "Equipment Emissions",
  equipment_master_add: "Add Equipment",
  copy_from_master: "Copy From Master",
  equipment_master_edit: "Edit Equipment",
  emissionFactor: "Emission Factor",
  vehicle: "Vehicle",
  milesgallons_or_kmLitres: "Miles/Gallons or KM/Litres",
  emission_factor: "Emission Factor",
  vehicle_emission_add: "Add Vehicle Emission",
  vehicle_master_edit: "Edit Vehicle Emission",
  vehicle_master_add: "Add Vehicle Emission",
  vehicle_emission: "Vehicle Emission",
  vehicle_master_copy: "Copy from Master",
  equipment: "Equipment",
  emissions: "Emissions",
  category: "Category",
  brand: "Brand",
  model: "Model",
  emission_settings: "Emission Settings",
  emission_settings_description: "Emission tracking will be enabled",
  transport_round_trip_settings_description:
    "Transport round trip will be enabled",
  transport_round_trip_settings: "Transport Round Trip Settings",
  vehicle_emissions: "Vehicle Emissions",
  organization_info: "Organization Info",
  organization_users: "Organization Users",
  organization_activity: "Organization Activity",
  user_information: "User Information",
  associated_organizations: "Associated Organization",
  associated_projects: "Associated Projects",
  user_activity: "User Activity",
  vehicles_manager: "Vehicles Manager",
  vehicle_type_added: "Vehicle type added",
  vehicle_type_updated: "Vehicle type updated",
  vehicle_type_deleted: "Vehicle type removed",
  no_vehicles_found: "No Vehicles Found",
  add_vehicle: "Add New Vehicle Type",
  multi_vehicle_description:
    "With a multi-chekin booking, you can defined how many vehicles are going to arrive at site, rather than make an individual booking for each.",
  recurring_description:
    "You can schedule a booking to repeat each week or month at a set time and date. For example, weekly garbage collection.",
  resource_only_description:
    "You can book only the available resources without taking booking space at an access point.",
  multi_resource_description:
    "You can enable or disable the ability to assign and manage multiple resources for a booking at the site level. When enabled, users can select and allocate more than one resource to a single booking. When disabled, bookings are limited to a single resource assignment.",  
  multi_vehicle: "Multi Vehicle",
  recurring: "Recurring",
  resource_only: "Resource Only",
  multi_resource: "Multi Resource",
  resource: "Resource",
  invite_user: "Invite User",
  add_another: "Add Another",
  role: "Role",
  project_admin: "Project Admin",
  project_manager: "Project Manager",
  project_user: "Project User",
  send_invite: "Send Invite",
  invite_sent: "Successfully Sent Invite",
  security_guard: "Security Guard",
  view_only: "View Only",
  project_senior_user: "Project Senior User",
  profile: "Profile",
  language: "Language",
  flexible_forms: "Flexible Forms",
  add_preset_form: "Add Preset Form",
  create_preset_form: "Create New Form",
  update_preset_form: "Update Form",
  order: "Order",
  form: "Form",
  preset_form: "Preset Form",
  add_question: "Add New Question",
  remove_question: "Remove This Question",
  add_section: "Add Section",
  form_title: "Form Title",
  form_title_is_required: "Form Title is required",
  location_type: "Location",
  section_title: "Section Title",
  section_title_is_required: "Section Title is required",
  new_question: "NEW QUESTION",
  no_flex_form: "No flexible forms set",
  check_in_form: "Checkin Form",
  check_out_form: "Checkout Form",
  booking: "Booking",
  checkin: "Checkin",
  checkout: "Checkout",
  form_updated_successfully: "Form updated successfully",
  form_created_successfully: "Form created successfully",
  label: "Label",
  question_title: "Title",
  form_deleted_successfully: "Successfully deleted form",
  go_to_section_base_on_answer: "Go to section based on answer",
  continue_to: "Continue to",
  "Project Admin": "Admin",
  "Project Manager": "Manager",
  "Project Owner": "Owner",
  "Project User": "User",
  "Environment Admin": "Environment Admin",
  "Equipment Analytics Admin": "Equipment Analytics Admin",
  "Project Senior User": "Project Senior User",
  "Supplier Equipment Coordinator": "Supplier Equipment Coordinator",
  "View Only": "View Only",
  
  name: "Name",
  role_name: "Role Name",
  role_name_required: "Role Name Required",
  role_code: "Role Code",
  users_count: "Users Count",
  create_role: "Create New Role",
  update_role: "Update Role",
  permissions: "Permissions",
  role_created: "New Role Created",
  role_permissions_updated: "Role Permissions Updated",
  roles: "Roles",
  total_roles: "Total Roles",
  select_all: "SELECT ALL",
  trade_type: "Trade Type",
  trade_types: "Trade Types",
  select_trade_type: "Select organization trade type",
  error_tradeType_required: "Trade Type is required",

  // Trade Type translation
  existing_building_demolition: "Existing Building Demolition",
  cip_concrete__precast_concrete__rebar:
    "CIP concrete, precast concrete, rebar",
  cmu: "CMU",
  structural_steel_framing__steel_decking__cold_formed_metal_framing:
    "Structural Steel Framing, Steel Decking, Cold Formed Metal Framing",
  rough_carpentry: "Rough carpentry",
  thermal_insulation_for_gwb_assemblies_and_roofing__roofing_and_siding_panels__membrane_roofing:
    "Thermal insulation for GWB assemblies and roofing, roofing and siding panels, membrane roofing",
  doors__frames__hardware__interior_and_exterior_glazing__specialty_doors:
    "Doors, Frames, Hardware, Interior and Exterior Glazing, Specialty Doors",
  gwb_assemblies__paint_and_coatings__flooring__acoustical_ceilings:
    "GWB assemblies, paint and coatings, flooring, acoustical ceilings",
  site_concrete_and_asphalt_paving: "Site concrete and asphalt paving",
  earthwork_and_utilities: "Earthwork and utilities",
  platforms: "Platforms",
  create_platform: "Create Platform",
  edit_platform: "Edit Platform",
  total_platforms: "Total Platforms",
  description: "Description",
  url: "URL",
  custom_duration: "Custom Duration",
  webhooks: "Webhooks",
  create_webhook: "Create Webhook",
  edit_webhook: "Edit Webhook",
  total_Webhooks: "Total Webhooks",
  global_masters: "Global Masters",
  equipment_master: "Equipment Master",
  vehicle_master: "Vehicle Master",
  platform: "Platform",
  events: "Events",
  listening_for: "Listening for",
  request_filters: "Request Filters",
  by_webhook_events: "By Webhook Events",
  by_webhook_statuses: "By Webhook Statuses",
  statuses_selected: "Statuses selected",
  events_selected: "Events selected",
  requested_at: "Requested At",
  event: "Event",

  my_account: "My Account",
  account_info: "Account Info",
  info: "Info",
  preferences: "Preferences",
  my_preferences: "My Preferences",
  user_created_at: "User Created At",
  user_last_update_at: "User Last Update At",
  projects: "Projects",
  own_org_projects:"Own Organization Projects",
  associated_org_projects:"Associated Organization Projects",
  date_format: "Date Format",
  time_format: "Time Format",
  calendar_start_day: "Calendar Start Day",
  select_platform: "Select Platform",

  // Trade Type translation
  None: "------------------------------------",
  "Existing Building Demolition": "Existing Building Demolition",
  "CIP concrete, precast concrete, rebar":
    "CIP concrete, precast concrete, rebar",
  CMU: "CMU",
  "Structural Steel Framing, Steel Decking, Cold Formed Metal Framing":
    "Structural Steel Framing, Steel Decking, Cold Formed Metal Framing",
  "Rough carpentry": "Rough carpentry",
  "Thermal insulation for GWB assemblies and roofing, roofing and siding panels, membrane roofing":
    "Thermal insulation for GWB assemblies and roofing, roofing and siding panels, membrane roofing",
  "Doors, Frames, Hardware, Interior and Exterior Glazing, Specialty Doors":
    "Doors, Frames, Hardware, Interior and Exterior Glazing, Specialty Doors",
  "GWB assemblies, paint & coatings, flooring, acoustical ceilings":
    "GWB assemblies, paint & coatings, flooring, acoustical ceilings",
  "Site concrete and asphalt paving": "Site concrete and asphalt paving",
  "Earthwork & utilities": "Earthwork & utilities",
  "Temporary Construction": "Temporary Construction",
  "Frame construction": "Frame construction",
  "Finishing construction": "Finishing construction",
  "Equipment construction": "Equipment construction",
  "Miscellaneous construction": "Miscellaneous construction",

  // Backend Text
  booking_contact: "Booking Contact",
  comments: "Comments",
  phone_number: "Phone Number",
  project_role: "Project Role",
  project_role_updated: "Project Role Updated",
  Van: "Van",
  "18 Wheeler": "18 Wheeler",
  "Box Truck": "Box Truck",
  "Car + Trailer": "Car + Trailer",
  Car: "Car",
  "Concrete Truck": "Concrete Truck",
  "Dump Truck": "Dump Truck",
  "Flatbed Truck": "Flatbed Truck",
  "Garbage Truck": "Garbage Truck",
  "Mobile Crane": "Mobile Crane",
  Other: "Other",
  "Pickup Truck": "Pickup Truck",
  "Pump Truck": "Pump Truck",
  Tanker: "Tanker",
  "Articulated Vehicle": "Articulated Vehicle",
  "Raised Floor Trailer": "Raised Floor Trailer",
  "Low Floor Trailer": "Low Floor Trailer",
  "15t Flat Truck": "15t Flat Truck",
  "15t Unic Truck": "15t Unic Truck",
  "10t Flat Truck": "10t Flat Truck",
  "10t Unic Truck": "10t Unic Truck",
  "8t Flat Truck": "8t Flat Truck",
  "8t Unic Truck": "8t Unic Truck",
  "4t Flat Truck": "4t Flat Truck",
  "4t Unic Truck": "4t Unic Truck",
  "2t Flat Truck": "2t Flat Truck",
  "2t_Flat_Truck": "2t Flat Truck",
  "Concrete Mixer Truck": "Concrete Mixer Truck",
  "16t Rough Terrain-Crane": "16t Rough Terrain-Crane",
  "25t Rough Terrain-Crane": "25t Rough Terrain-Crane",
  "50t Rough Terrain-Crane": "50t Rough Terrain-Crane",
  "65t Rough Terrain-Crane": "65t Rough Terrain-Crane",
  "10t dump truck": "10t Dump Truck",
  "10t Dump Truck": "10t Dump Truck",
  "10t arm roll": "10t Arm Roll",
  "10t Arm Roll": "10t Arm Roll",
  "4t arm roll": "4t Arm Roll",
  "4t Arm Roll": "4t Arm Roll",
  "WIRE FEEDER": "Wire Feeder",
  "Excavator": "Excavator",
  "TRUCK": "Truck",
  "WELDER": "Welder",
  "TELEHANDLERS": "Telehandlers",
  "FORKLIFTS": "Forklifts",
  "SCISSOR LIFTS": "Scissor Lifts",
  "ARTICULATING BOOMS": "Articulating Booms",
  "Loader": "Loader",
  "Truck Crane": "Truck Crane",
  "Rough Terrain Crane": "Rough Terrain Crane",
  "Crawler Crane": "Crawler Crane",
  "Boom Lift": "Boom Lift",
  "Straight Forklift": "Straight Forklift",
  "Reach Forklift": "Reach Forklift",
  "Crane": "Crane",
  "Hoist": "Hoist",
  "Pressure Washer": "Pressure Washer",
  "Scissor Lift": "Scissor Lift",
  "Track Loader": "Track Loader",
  "ForkLift": "ForkLift",


  // System Banners
  system_banners: "System Banners",
  create_banner: "Create Banner",
  edit_banner: "Edit Banner",
  banner_title: "Title",
  banner_message: "Message",
  banner_html_content: "HTML Content (Optional)",
  banner_type: "Type",
  banner_priority: "Priority",
  banner_display_mode: "Display Mode",
  banner_target_type: "Target Type",
  banner_start_date: "Start Date",
  banner_end_date: "End Date (Optional)",
  banner_detail_url: "Detail URL (Optional)",
  banner_active: "Active",
  banner_dismissible: "Dismissible",
  select_project: "Select Project",
  select_organization: "Select Organization",
  all_users: "All Users",
  users_with_role: "Users with Role",
  global_banner: "Global Banner",
  after_login_popup: "After Login Popup",
  homepage_banner: "Homepage Banner",
  notification: "Notification",
  disaster_alert: "Disaster Alert",
  maintenance: "Maintenance",
  system_issue: "System Issue",
  general: "General",
  low: "Low",
  medium: "Medium",
  high: "High",
  critical: "Critical",
  banner_created_successfully: "Banner created successfully",
  banner_updated_successfully: "Banner updated successfully",
  banner_deleted_successfully: "Banner deleted successfully",
  failed_to_load_system_banners: "Failed to load system banners",
  failed_to_delete_banner: "Failed to delete banner",
  failed_to_save_banner: "Failed to save banner",
  are_you_sure_delete_banner: "Are you sure you want to delete this banner?",
  no_banners_found: "No banners found",
  target: "Target",
  update: "Update",
  create: "Create",

  // System Banner Error Messages
  Err_system_banner_mark_as_read_failed: "Failed to mark banner as read",
  Err_system_banner_mark_as_read_error: "An error occurred while marking banner as read",
  all_items_loaded: "All items loaded",
  total: "total",
  loading: "Loading",
  error_loading_more: "Error loading more items",
  retry: "Retry",
  project_create_under_org: "This project will be created under {{org}}.",
  project_create_owner_cross_org:
    "You can only create projects for your own organization ({{org}}). This owner belongs to {{ownerOrg}}.",
  Err_can_only_create_for_own_organization:
    "You can only create projects for your own organization.",

  // Global Variables (BUGS-504)
  global_variables: "Global Variables",
  anthropic_key: "Anthropic Key",
  anthropic_model: "Anthropic Model",
  anthropic_key_help:
    "Used by every SCP AI feature: Co-pilot, supplier import, PO and BOM PDF checks, Material Categorization and EPD parsing. The saved key is never shown in full.",
  current_key: "Current key",
  new_key: "New key",
  enter_new_anthropic_key: "Paste the new Anthropic key",
  clear_key: "Clear key",
  anthropic_key_clear_confirm:
    "Clear the Anthropic key? SCP's AI features will stop working until a new key is saved.",
  key_not_set: "Not set. SCP's AI features are off until a key is saved.",
  copilot_model: "Co-pilot Model",
  copilot_model_help: "Used by Co-pilot, supplier import from PDF, the PO and BOM PDF checks, and EPD parsing.",
  categorization_model: "Categorization Model",
  categorization_model_help:
    "Used by AI Material Categorization only. Kept separate so it can stay on a cheaper model.",
  last_updated_by: "Last updated by {{user}} on {{date}}",
  global_variable_saved: "Saved. SCP uses it from its next AI request (within 10 minutes at the latest).",
  loading_models: "Loading the models available for the saved key…",
  failed_to_load_models: "Failed to load the available models",
  go_to_anthropic_key: "Go to Anthropic Key",
  model_not_in_list: "{{model}} (not available for the saved key)",
  model_context_window: "Context window: {{tokens}} tokens",
  model_max_output: "Max output: {{tokens}} tokens",
  model_released: "Released: {{date}}",
  model_supports: "Supports: {{list}}",
  capability_vision: "Images",
  capability_adaptive_thinking: "Adaptive thinking",
  capability_structured_outputs: "Structured outputs",
  capability_effort: "Effort control",
  Err_anthropic_key_not_set: "Save the Anthropic key first; the model list is loaded with it.",
  Err_anthropic_key_invalid: "Anthropic rejected the saved key. Please check the Anthropic Key page.",
  Err_anthropic_unavailable: "Anthropic could not be reached. Please try again in a moment.",
  Err_model_not_available: "This model is not available for the saved key.",
  Err_model_required: "Please choose a model.",
  failed_to_load_global_variables: "Failed to load global variables",
  failed_to_save_global_variable: "Failed to save the change",
  global_variables_no_access: "Only Voyage Control global admins can view Global Variables.",

  // Inventory Ledger Alerts (BUGS-535)
  inventory_ledger_alerts: "Inventory Ledger Alerts",
  inventory_ledger_alerts_help:
    "Who receives an email when the nightly inventory ledger job fails, partly fails, or finds that earlier runs were missed. Enter one email address, or several separated by commas. This can be a shared mailbox or a person.",
  ledger_alert_recipients: "Alert recipients",
  current_recipients: "Current recipients",
  recipients: "Recipients",
  enter_ledger_alert_emails: "e.g. stock-team@company.com, jane.doe@company.com",
  ledger_alerts_not_set: "Not set. Ledger alerts are written to the log only.",
  ledger_alerts_clear_confirm: "Clear the alert recipients? Ledger alerts will only be written to the log.",
  ledger_alerts_saved: "Saved. The change applies to the next ledger alert (within 10 minutes at the latest).",
  clear: "Clear",
  Err_invalid_email_list: "These are not valid email addresses: {{list}}.",
};
export default Translation;
